import React, { useEffect, useState } from 'react'
import "./nav.css"
import {useNavigate} from "react-router-dom"
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Whatshot, Movie, Search, Tv } from '@material-ui/icons';


const useStyles = makeStyles({
  root: {
    width: "100%",
    position: "fixed",
    bottom: 0,
    background: "#4a0a48",
    boxShadow: '0 -3px 10px black',
    zIndex: 100,
    transition: ".6s",
    '&:hover': {
      transform: "scale(105%)"
    }
  },
})

// bottom navigation
const MainNav = () => {
  const navigate = useNavigate()
  const classes = useStyles()
  const [value, setValue] = useState("")

  useEffect(() => {
    if (value===0) navigate("/")
    else if(value===1) navigate("/movies")
    else if(value===2) navigate("/series")
    else if(value===3) navigate("/search")
  }, [value, navigate])
  
  return (
    <BottomNavigation
      className={classes.root}
      showLabels
      value={value}
      onChange={(e, newValue) => {
        setValue(newValue);
      }}
    >
      <BottomNavigationAction label="Trending" icon={<Whatshot className='nav-icon' />}
      
      />
      <BottomNavigationAction label="Movies" icon={<Movie className='nav-icon' />} />
      <BottomNavigationAction label="TV Series" icon={<Tv className='nav-icon' />} />
      <BottomNavigationAction label="Search" icon={<Search className='nav-icon' />} />
    </BottomNavigation>
  )
}

export default MainNav
